var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrapper"},[(_vm.isCouponField)?_c('span',{staticClass:"input-icon"},[_c('img',{attrs:{"src":require("@/assets/images/intermarche/coupon-icon.png"),"alt":"Coupon","width":"23"}})]):_vm._e(),_c('input',{class:[
      _vm.hasError ? 'has-error' : '', 
      _vm.$i18n.locale === 'ar' ? 'arabic-text' : '',
      _vm.isCouponField ? 'set-left-padding' : ''
    ],attrs:{"type":_vm.fieldType,"placeholder":_vm.placeholder,"required":_vm.isRequiredValue,"disabled":_vm.isDisabled},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.$emit('update:modelValue', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }